// @ts-nocheck
﻿import { useEffect } from 'react';

export const Logout = ({ returnTo, ...props }) => {

    useEffect(()=>{
        window.localStorage.removeItem("refreshToken");
        
        document.cookie = "Activate-Token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        document.cookie = ".Activate.Session=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";

        window.location.href="/";
    },[]);

   return null;

};